/* eslint-disable no-restricted-syntax */
import _t from 'i18n!nls/stackability-common';

const getDegreesPathwaysCopy = () => ({
  myLearningTab: {
    offersCreditDisclaimer: _t(
      '¹Each university determines the number of credits that may count towards the degree requirements based on institutional policies, which may consider existing credits you may have.'
    ),
    updatedOffersCreditDisclaimer: _t(
      '¹Each university determines the number of pre-approved prior learning credits that may count towards the degree requirements according to institutional policies. '
    ),
    singleDegreeUpsell: {
      offersCreditCopy: {
        title: (degreeName: string) =>
          _t('Your completion may earn you credit towards the #{degreeName} degree', { degreeName }),
        body: (productVariant: string, partnerName: string) =>
          _t(
            'If you are admitted and enroll, your completion of this #{productVariant} may earn you prior learning credit toward this degree program from #{partnerName}.¹',
            { productVariant, partnerName }
          ),
      },
      partOfCopy: {
        title: (productVariant: string, degreeName: string) =>
          _t('This #{productVariant} is part of the #{degreeName} degree', {
            productVariant,
            degreeName,
          }),
        body: (productVariant: string, partnerName: string) =>
          _t(
            'If you are admitted and enroll, your completion of this #{productVariant} may provide progress toward this degree program from #{partnerName}.',
            { productVariant, partnerName }
          ),
      },
      relatedToCopy: {
        title: (degreeName: string) => _t("You've started preparing for the #{degreeName} degree", { degreeName }),
        body: (productVariant: string, partnerName: string, disableEOIVerbiage: boolean) =>
          disableEOIVerbiage
            ? _t(
                'Your completion of this #{productVariant} may have provided you with a preview of the topics, materials and instructors in this degree program from #{partnerName}. View the program to decide if it might be a good fit for your career goals.',
                { productVariant, partnerName }
              )
            : _t(
                'Your completion of this #{productVariant} may have provided you with a preview of the topics, materials and instructors in this degree program from #{partnerName}. View the program or request info to decide if it might be a good fit for your career goals.',
                { productVariant, partnerName }
              ),
      },
    },
    multipleDegreeUpsells: {
      offersCreditCopy: {
        title: _t('Your completion may earn you credit towards a degree'),
        body: (productVariant: string) =>
          _t(
            'By completing this #{productVariant}, you may be eligible to earn prior learning credit toward one of these eligible degree programs if you are admitted and enroll.¹',
            { productVariant }
          ),
      },
      partOfCopy: {
        title: (productVariant: string) =>
          _t('This #{productVariant} is part of multiple degree programs', { productVariant }),
        body: (productVariant: string) =>
          _t(
            'If you are admitted and enroll, your completion of this #{productVariant} may provide progress toward one of these degree programs.',
            { productVariant }
          ),
      },
      relatedToCopy: {
        title: _t("You've started preparing for a degree"),
        body: (productVariant: string) =>
          _t(
            'Your completion of this #{productVariant} may have provided you with a preview of the topics, materials and instructors from a related degree program. View the programs to decide which one might be a good fit for your career goals.',
            { productVariant }
          ),
      },
    },
  },
});

export default getDegreesPathwaysCopy;
